const funcs = {
    getSettingsProperty: function(handle, property) {
        return axios.get(handle.$config.get("dns") + handle.$config.get("basePathFiles") + "static/config/settings.json").then(configSettings => {
            if (configSettings.data[property]){
                return configSettings.data[property];
            } else {
                return axios.get(handle.$config.get("dns") + handle.$config.get("basePathFiles") + "static/current/config/settings.json").then(curresntConfigSettings => {
                    if (curresntConfigSettings.data[property]) {
                        return curresntConfigSettings.data[property];
                    } else {
                        return false;
                    }
                }).catch(error => {
                    console.error("Could not find settings. Please contact your administrator.")
                    console.error(error)
                    return false
                });
            }
        }).catch(error => {
            console.error(error)
            return axios.get(handle.$config.get("dns") + handle.$config.get("basePathFiles") + "static/current/config/settings.json").then(curresntConfigSettings => {
                if (curresntConfigSettings.data[property]) {
                    return curresntConfigSettings.data[property];
                } else {
                    return false;
                }
            });
        })
    }
}

export default funcs;